

// LIVE
// const baseUrl = "https://api.equityresearchmart.in:443";

// LOCAL
const baseUrl = "https://localhost:7021";

const appApiEndPoints = {
  recaptchaVerify: `${baseUrl}/api/Recaptcha/verify`,
};

export default appApiEndPoints;
